interface VideoPlayButtonProps {
  width?: "48" | "64" | "80";
  height?: "48" | "64" | "80";
}

const VideoPlayButton = ({
  width = "48",
  height = "48",
}: VideoPlayButtonProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="24" cy="24" r="24" fill="#B8EECD" />
    <path
      d="M32 24L20 16V32L32 24Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default VideoPlayButton;
